import React from 'react';

function TTOReportDisplay({ priorArtResults }) {
  if (!priorArtResults || priorArtResults.report_type !== 'tto') {
    return null;
  }

  return (
    <div style={{ background: '#1a237e', padding: '24px', borderRadius: '8px', color: 'white', marginBottom: '24px' }}>
      
      {/* TTO Report Header */}
      <div style={{ marginBottom: '24px', borderBottom: '2px solid rgba(255,255,255,0.3)', paddingBottom: '16px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 'bold', margin: 0 }}>TTO Prior Art & Commercial IP Assessment</h2>
        <p style={{ fontSize: '14px', opacity: 0.8, marginTop: '8px' }}>Decision-support document for Technology Transfer Office</p>
      </div>

      {/* Publication Warning */}
      {priorArtResults.tto_executive_summary?.publication_warning && (
        <div style={{ background: '#c62828', padding: '16px', borderRadius: '8px', marginBottom: '24px', border: '3px solid #ff5252' }}>
          <h3 style={{ fontSize: '16px', fontWeight: 'bold', margin: '0 0 8px 0' }}>⚠️ PUBLICATION HOLD</h3>
          <p style={{ fontSize: '14px', margin: 0 }}>{priorArtResults.tto_executive_summary.publication_warning_text}</p>
        </div>
      )}

      {/* Decision Matrix */}
      <div style={{ background: 'rgba(255,255,255,0.1)', padding: '20px', borderRadius: '8px', marginBottom: '24px' }}>
        <h3 style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '16px' }}>TTO Decision Matrix</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px' }}>
          <div style={{ background: 'rgba(255,255,255,0.1)', padding: '12px', borderRadius: '6px' }}>
            <div style={{ fontSize: '12px', opacity: 0.7, marginBottom: '4px' }}>Novelty</div>
            <div style={{ fontSize: '18px', fontWeight: 'bold', color: priorArtResults.tto_executive_summary?.novelty_rating === 'High' ? '#4caf50' : priorArtResults.tto_executive_summary?.novelty_rating === 'Medium' ? '#ff9800' : '#f44336' }}>
              {priorArtResults.tto_executive_summary?.novelty_rating || 'Unknown'}
            </div>
            <div style={{ fontSize: '11px', opacity: 0.7, marginTop: '4px' }}>{priorArtResults.tto_executive_summary?.novelty_rationale}</div>
          </div>
          <div style={{ background: 'rgba(255,255,255,0.1)', padding: '12px', borderRadius: '6px' }}>
            <div style={{ fontSize: '12px', opacity: 0.7, marginBottom: '4px' }}>Inventive Step</div>
            <div style={{ fontSize: '18px', fontWeight: 'bold', color: priorArtResults.tto_executive_summary?.inventive_step_rating === 'High' ? '#4caf50' : priorArtResults.tto_executive_summary?.inventive_step_rating === 'Medium' ? '#ff9800' : '#f44336' }}>
              {priorArtResults.tto_executive_summary?.inventive_step_rating || 'Unknown'}
            </div>
            <div style={{ fontSize: '11px', opacity: 0.7, marginTop: '4px' }}>{priorArtResults.tto_executive_summary?.inventive_step_rationale}</div>
          </div>
          <div style={{ background: 'rgba(255,255,255,0.1)', padding: '12px', borderRadius: '6px' }}>
            <div style={{ fontSize: '12px', opacity: 0.7, marginBottom: '4px' }}>Market Potential</div>
            <div style={{ fontSize: '18px', fontWeight: 'bold', color: priorArtResults.tto_executive_summary?.market_potential_rating === 'High' ? '#4caf50' : priorArtResults.tto_executive_summary?.market_potential_rating === 'Medium' ? '#ff9800' : '#f44336' }}>
              {priorArtResults.tto_executive_summary?.market_potential_rating || 'Unknown'}
            </div>
            <div style={{ fontSize: '11px', opacity: 0.7, marginTop: '4px' }}>{priorArtResults.tto_executive_summary?.market_potential_rationale}</div>
          </div>
          <div style={{ background: 'rgba(255,255,255,0.1)', padding: '12px', borderRadius: '6px' }}>
            <div style={{ fontSize: '12px', opacity: 0.7, marginBottom: '4px' }}>FTO Risk</div>
            <div style={{ fontSize: '18px', fontWeight: 'bold', color: priorArtResults.tto_executive_summary?.fto_risk_rating === 'Low' ? '#4caf50' : priorArtResults.tto_executive_summary?.fto_risk_rating === 'Medium' ? '#ff9800' : '#f44336' }}>
              {priorArtResults.tto_executive_summary?.fto_risk_rating || 'Unknown'}
            </div>
            <div style={{ fontSize: '11px', opacity: 0.7, marginTop: '4px' }}>{priorArtResults.tto_executive_summary?.fto_risk_rationale}</div>
          </div>
        </div>
      </div>

      {/* Primary Recommendation */}
      <div style={{ background: priorArtResults.tto_executive_summary?.recommendation === 'File Immediately' ? '#2e7d32' : priorArtResults.tto_executive_summary?.recommendation === 'Do Not File' ? '#c62828' : '#f57c00', padding: '20px', borderRadius: '8px', marginBottom: '24px' }}>
        <h3 style={{ fontSize: '14px', fontWeight: 'bold', margin: '0 0 8px 0', opacity: 0.9 }}>PRIMARY RECOMMENDATION</h3>
        <div style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '8px' }}>{priorArtResults.tto_executive_summary?.recommendation || 'Assessment Required'}</div>
        <p style={{ fontSize: '14px', margin: 0, opacity: 0.9 }}>{priorArtResults.tto_executive_summary?.recommendation_rationale}</p>
      </div>

      {/* Executive Summary */}
      <div style={{ background: 'rgba(255,255,255,0.95)', padding: '20px', borderRadius: '8px', marginBottom: '24px', color: '#333' }}>
        <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#1a237e', marginBottom: '12px' }}>Executive Summary</h3>
        <p style={{ fontSize: '14px', lineHeight: '1.6', marginBottom: '16px' }}>{priorArtResults.tto_executive_summary?.summary_paragraph}</p>
        
        <h4 style={{ fontSize: '14px', fontWeight: 'bold', color: '#2e7d32', marginBottom: '8px' }}>Key Differentiators</h4>
        <ul style={{ margin: '0 0 16px 0', paddingLeft: '20px' }}>
          {priorArtResults.tto_executive_summary?.key_differentiators?.map((item, i) => (
            <li key={i} style={{ fontSize: '13px', marginBottom: '4px' }}>{item}</li>
          ))}
        </ul>
        
        <h4 style={{ fontSize: '14px', fontWeight: 'bold', color: '#c62828', marginBottom: '8px' }}>Primary Risks</h4>
        <ul style={{ margin: 0, paddingLeft: '20px' }}>
          {priorArtResults.tto_executive_summary?.primary_risks?.map((item, i) => (
            <li key={i} style={{ fontSize: '13px', marginBottom: '4px' }}>{item}</li>
          ))}
        </ul>
      </div>

      {/* Prior Art Landscape */}
      {priorArtResults.tto_prior_art_landscape && (
        <div style={{ background: 'rgba(255,255,255,0.95)', padding: '20px', borderRadius: '8px', marginBottom: '24px', color: '#333' }}>
          <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#1a237e', marginBottom: '12px' }}>Prior Art Landscape</h3>
          <p style={{ fontSize: '14px', lineHeight: '1.6', marginBottom: '16px' }}>{priorArtResults.tto_prior_art_landscape.landscape_summary}</p>
          
          <h4 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '8px' }}>Closest References</h4>
          {priorArtResults.tto_prior_art_landscape.closest_references?.map((ref, i) => (
            <div key={i} style={{ background: '#f5f5f5', padding: '12px', borderRadius: '6px', marginBottom: '8px' }}>
              <div style={{ fontWeight: 'bold', color: '#1565c0' }}>
                <a href={'https://patents.google.com/patent/' + (ref.patent_number || ref.reference || '').replace(/^US/, 'US')} target="_blank" rel="noopener noreferrer" style={{ color: '#1565c0', textDecoration: 'none' }}>
                  {ref.patent_number || ref.reference}
                </a>
                {ref.owner && ` - ${ref.owner}`}
              </div>
              <div style={{ fontSize: '13px', marginTop: '4px' }}>{ref.summary}</div>
              <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                <span style={{ color: '#c62828' }}>Overlap:</span> {ref.key_overlap} | <span style={{ color: '#2e7d32', marginLeft: '8px' }}>Gaps:</span> {ref.key_gaps}
              </div>
            </div>
          ))}
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginTop: '16px' }}>
            <div>
              <h4 style={{ fontSize: '13px', fontWeight: 'bold', color: '#2e7d32', marginBottom: '8px' }}>White Space Opportunities</h4>
              <ul style={{ margin: 0, paddingLeft: '16px', fontSize: '12px' }}>
                {priorArtResults.tto_prior_art_landscape.white_space_opportunities?.map((item, i) => (
                  <li key={i} style={{ marginBottom: '4px' }}>{item}</li>
                ))}
              </ul>
            </div>
            <div>
              <h4 style={{ fontSize: '13px', fontWeight: 'bold', color: '#c62828', marginBottom: '8px' }}>Crowded Areas</h4>
              <ul style={{ margin: 0, paddingLeft: '16px', fontSize: '12px' }}>
                {priorArtResults.tto_prior_art_landscape.crowded_areas?.map((item, i) => (
                  <li key={i} style={{ marginBottom: '4px' }}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
          
          <div style={{ background: '#e3f2fd', padding: '12px', borderRadius: '6px', marginTop: '16px' }}>
            <h4 style={{ fontSize: '13px', fontWeight: 'bold', color: '#1565c0', marginBottom: '4px' }}>TTO Interpretation</h4>
            <p style={{ fontSize: '13px', margin: 0 }}>{priorArtResults.tto_prior_art_landscape.tto_interpretation}</p>
          </div>
        </div>
      )}

      {/* Commercial Potential */}
      {priorArtResults.tto_commercial_potential && (
        <div style={{ background: 'rgba(255,255,255,0.95)', padding: '20px', borderRadius: '8px', marginBottom: '24px', color: '#333' }}>
          <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#1a237e', marginBottom: '12px' }}>Commercial Potential</h3>
          <p style={{ fontSize: '14px', lineHeight: '1.6', marginBottom: '16px' }}>{priorArtResults.tto_commercial_potential.market_summary}</p>
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
            <div style={{ background: '#e8f5e9', padding: '12px', borderRadius: '6px' }}>
              <div style={{ fontSize: '12px', color: '#666' }}>Licensing Potential</div>
              <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#2e7d32' }}>{priorArtResults.tto_commercial_potential.licensing_potential}</div>
              <div style={{ fontSize: '11px', color: '#666' }}>{priorArtResults.tto_commercial_potential.licensing_rationale}</div>
            </div>
            <div style={{ background: '#fff3e0', padding: '12px', borderRadius: '6px' }}>
              <div style={{ fontSize: '12px', color: '#666' }}>Spinout Potential</div>
              <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#f57c00' }}>{priorArtResults.tto_commercial_potential.spinout_potential}</div>
              <div style={{ fontSize: '11px', color: '#666' }}>{priorArtResults.tto_commercial_potential.spinout_rationale}</div>
            </div>
          </div>
          
          <h4 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '8px' }}>Target Markets</h4>
          {priorArtResults.tto_commercial_potential.target_markets?.map((market, i) => (
            <div key={i} style={{ background: '#f5f5f5', padding: '8px 12px', borderRadius: '4px', marginBottom: '6px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontWeight: '600' }}>{market.market}</span>
              <span style={{ fontSize: '12px', padding: '2px 8px', background: market.market_size_indication === 'Large' ? '#4caf50' : '#ff9800', color: 'white', borderRadius: '4px' }}>{market.market_size_indication}</span>
            </div>
          ))}
        </div>
      )}

      {/* FTO Snapshot */}
      {priorArtResults.tto_fto_snapshot && (
        <div style={{ background: 'rgba(255,255,255,0.95)', padding: '20px', borderRadius: '8px', marginBottom: '24px', color: '#333' }}>
          <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#1a237e', marginBottom: '4px' }}>Freedom to Operate Snapshot</h3>
          <p style={{ fontSize: '11px', color: '#c62828', marginBottom: '12px', fontStyle: 'italic' }}>{priorArtResults.tto_fto_snapshot.disclaimer}</p>
          
          <div style={{ background: priorArtResults.tto_fto_snapshot.fto_risk_level === 'Low' ? '#e8f5e9' : priorArtResults.tto_fto_snapshot.fto_risk_level === 'Medium' ? '#fff3e0' : '#ffebee', padding: '12px', borderRadius: '6px', marginBottom: '16px' }}>
            <div style={{ fontSize: '12px', color: '#666' }}>Overall FTO Risk</div>
            <div style={{ fontSize: '24px', fontWeight: 'bold', color: priorArtResults.tto_fto_snapshot.fto_risk_level === 'Low' ? '#2e7d32' : priorArtResults.tto_fto_snapshot.fto_risk_level === 'Medium' ? '#f57c00' : '#c62828' }}>
              {priorArtResults.tto_fto_snapshot.fto_risk_level}
            </div>
            <p style={{ fontSize: '13px', margin: '8px 0 0 0' }}>{priorArtResults.tto_fto_snapshot.fto_summary}</p>
          </div>
          
          {priorArtResults.tto_fto_snapshot.potential_blocking_patents?.length > 0 && (
            <div>
              <h4 style={{ fontSize: '14px', fontWeight: 'bold', color: '#c62828', marginBottom: '8px' }}>Potential Blocking Patents</h4>
{priorArtResults.tto_fto_snapshot.potential_blocking_patents.map((patent, i) => (
                <div key={i} style={{ background: '#ffebee', padding: '10px', borderRadius: '4px', marginBottom: '6px' }}>
                  <div style={{ fontWeight: 'bold' }}>
                    <a href={'https://patents.google.com/patent/' + (patent.patent_number || patent.patent || '').replace(/^US/, 'US')} target="_blank" rel="noopener noreferrer" style={{ color: '#c62828', textDecoration: 'none' }}>
                      {patent.patent_number || patent.patent}
                    </a>
                    <span style={{ fontSize: '12px', color: '#c62828', marginLeft: '8px' }}>({patent.risk_level} Risk)</span>
                  </div>
                  <div style={{ fontSize: '12px', marginTop: '4px' }}>{patent.concern}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Recommendations */}
      {priorArtResults.tto_recommendations && (
        <div style={{ background: 'rgba(255,255,255,0.95)', padding: '20px', borderRadius: '8px', marginBottom: '24px', color: '#333' }}>
          <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#1a237e', marginBottom: '12px' }}>Recommendations & Action Plan</h3>
          
          <div style={{ background: '#e3f2fd', padding: '12px', borderRadius: '6px', marginBottom: '16px' }}>
            <h4 style={{ fontSize: '14px', fontWeight: 'bold', color: '#1565c0', marginBottom: '8px' }}>IP Strategy</h4>
            <div style={{ fontSize: '13px' }}>
              <div><strong>Filing Approach:</strong> {priorArtResults.tto_recommendations.ip_strategy_recommendation?.filing_approach}</div>
              <div style={{ marginTop: '4px' }}><strong>Claim Focus:</strong> {priorArtResults.tto_recommendations.ip_strategy_recommendation?.claim_focus}</div>
            </div>
          </div>
          
          <h4 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '8px' }}>Immediate Actions</h4>
          {priorArtResults.tto_recommendations.immediate_actions?.map((action, i) => (
            <div key={i} style={{ background: action.priority === 'Critical' ? '#ffebee' : '#fff3e0', padding: '10px', borderRadius: '4px', marginBottom: '6px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <div style={{ fontWeight: '600' }}>{action.action}</div>
                <div style={{ fontSize: '12px', color: '#666' }}>Owner: {action.owner} | Timeline: {action.timeline}</div>
              </div>
              <span style={{ fontSize: '11px', padding: '2px 8px', background: action.priority === 'Critical' ? '#c62828' : action.priority === 'High' ? '#f57c00' : '#4caf50', color: 'white', borderRadius: '4px' }}>{action.priority}</span>
            </div>
          ))}
          
          <div style={{ background: '#fafafa', padding: '12px', borderRadius: '6px', marginTop: '16px' }}>
            <h4 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '8px' }}>Budget Considerations</h4>
            <div style={{ fontSize: '13px' }}>
              <div><strong>Patent Filing:</strong> {priorArtResults.tto_recommendations.budget_considerations?.patent_filing_estimate}</div>
              <div><strong>Additional Searches:</strong> {priorArtResults.tto_recommendations.budget_considerations?.additional_searches_estimate}</div>
              <div><strong>FTO Analysis:</strong> {priorArtResults.tto_recommendations.budget_considerations?.fto_analysis_estimate}</div>
            </div>
          </div>
        </div>
      )}

      {/* Academic Papers Section */}
      {priorArtResults.papers && priorArtResults.papers.length > 0 && (
        <div style={{ background: 'rgba(255,255,255,0.1)', padding: '20px', borderRadius: '8px', marginBottom: '20px' }}>
          <h3 style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '16px' }}>
            Academic Papers ({priorArtResults.papers_count || priorArtResults.papers.length})
          </h3>
          <p style={{ fontSize: '13px', opacity: 0.8, marginBottom: '16px' }}>
            Non-patent literature from OpenAlex, Semantic Scholar, and Crossref. Papers published before the priority date may constitute prior art.
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {priorArtResults.papers.slice(0, 5).map((paper, idx) => (
              <div key={idx} style={{ background: 'rgba(255,255,255,0.1)', padding: '12px', borderRadius: '6px' }}>
                <div style={{ fontSize: '14px', fontWeight: '600', marginBottom: '4px' }}>
                  {paper.title?.substring(0, 80)}{paper.title?.length > 80 ? '...' : ''}
                </div>
                <div style={{ fontSize: '12px', opacity: 0.8 }}>
                  {paper.venue || 'Unknown venue'} • {paper.publication_year || 'N/A'} • {paper.cited_by_count || 0} citations
                </div>
                <div style={{ marginTop: '6px' }}>
                  <span style={{
                    fontSize: '11px',
                    padding: '2px 8px',
                    borderRadius: '4px',
                    background: paper.publication_status === 'BEFORE_FILING' ? '#16a34a' : 
                               paper.publication_status === 'AFTER_FILING' ? '#dc2626' : '#f59e0b',
                    color: 'white'
                  }}>
                    {paper.publication_status === 'BEFORE_FILING' ? 'Before Filing (Prior Art)' :
                     paper.publication_status === 'AFTER_FILING' ? 'After Filing' : 'Date Uncertain'}
                  </span>
                  <div style={{ display: 'flex', gap: '10px', marginLeft: '10px' }}>
                    {paper.doi && <a href={'https://doi.org/' + paper.doi} target="_blank" rel="noopener noreferrer" style={{ fontSize: '11px', color: '#90caf9', textDecoration: 'none' }}>View Paper ↗</a>}
                    {paper.pdf_url && <a href={paper.pdf_url} target="_blank" rel="noopener noreferrer" style={{ fontSize: '11px', color: '#90caf9', textDecoration: 'none' }}>PDF ↗</a>}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Disclaimer */}
      <div style={{ fontSize: '11px', opacity: 0.7, textAlign: 'center', padding: '16px' }}>
        This is a preliminary assessment for TTO decision-support purposes only. It is not legal advice and should not be relied upon for filing decisions.
        A qualified patent attorney must independently review and verify all findings before any prosecution strategy is determined.
      </div>
    </div>
  );
}

export default TTOReportDisplay;
